export const authCancelledCodes = [
  'auth/cancelled-popup-request',
  'auth/popup-closed-by-user',
];
